import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" className="text-sm text-gray-400" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1">
      {items.map((it, i) => (
        <li key={it.path} className="flex items-center gap-1">
          {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-gray-600" aria-hidden />}
          {i === items.length - 1 ? <span aria-current="page" className="text-gray-200">{it.name}</span> : <Link to={it.path} className="hover:text-gold">{it.name}</Link>}
        </li>
      ))}
    </ol>
  </nav>
);
